import astroganesh from "../../../assets/astroganesh.png";
import ravian from "../../../assets/ravian.png";
import edtech from "../../../assets/edtech.png";
const list = [
  {
    id: 1,
    projectHeading: "AstroGanesh",
    projectImage: astroganesh,
    aboutProject: `AstroGanesh is a comprehensive astrology platform designed to provide users with personalized astrological guidance through real-time interactions with expert astrologers. The platform supports role-based access for Admins, Users, and Astrologers, enabling secure authentication, OTP-based login, live chat consultations, wallet recharges, coupon management, and seamless payment integration. Built with scalability and user experience in mind, AstroGanesh delivers a smooth, responsive interface while ensuring reliable communication, secure transactions, and efficient platform management.`,
    technologies: "React, Next.js, Socket.io, Redux and Tailwind CSS",
    github: "",
    live: "https://astroganesh.in/",
  },
  {
    id: 2,
    projectHeading: "Ravian AI",
    projectImage: ravian,
    aboutProject: `Ravian AI is an AI-powered platform designed to build intelligent agents that automate complex workflows and enable real-time decision-making. I contributed to the frontend development by building responsive, scalable user interfaces, integrating real-time streaming APIs, and collaborating closely with backend and AI teams to deliver a high-performance user experience..`,
    technologies: "AWS, React.js, Node.js, Fast API and Tailwind CSS",
    github: "",
    live: "https://www.ravian.ai/",
  },
  {
    id: 3,
    projectHeading: "Study Notion",
    projectImage: edtech,
    aboutProject: `Developed a full-stack educational platform with role-based access for Admins, Instructors, and Students. Built admin tools for managing categories and content, instructor dashboards for creating and pricing courses, and student flows for browsing, purchasing, and enrollment. Worked across frontend and backend to build responsive UIs, integrate REST APIs, and handle end-to-end business logic. Deployed and maintained the application on Render for stable production performance.`,
    technologies:
      "JavaScript, React js, Node.js, Express.js, MongoDB, Vercel and Render",
    github: "https://github.com/abhishekraj15/edTechNotion",
    live: "https://edtechnotion.vercel.app/",
  },
];

export default list;
